import { Link } from 'react-router-dom';

import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import { stylePackThumbImages } from '../../../stylepacks/stylepack-resources';

import styles from './stylepacks-row.module.css';

const EmptyStylepacksRow = ({ stylepackSelected }: { stylepackSelected: boolean }) => {
  return (
    <Container
      height="85px"
      width="100%"
      borderRadius="12px"
      className="flex ai-center jc-space-between position-relative padding-24 overflow-hidden"
    >
      <Text className="H5">Unleash Your Creativity</Text>
      <Link to={stylepackSelected ? './stylepacks' : './stylepacks/browse'}>
        <Button
          border="1px solid var(--global-opacity-white-10-percent)"
          className="z-10"
          design="LocalBttnSecHalfTransp"
        >
          <Text>Browse</Text>
        </Button>
      </Link>

      <Container className={styles['bloom-effect']} />
      <Container className={styles['left-image']} backgroundImage={stylePackThumbImages['brandlive-academy']} />
      <Container className={styles['right-image']} backgroundImage={stylePackThumbImages['brandlive-tic-tac-toe']} />
    </Container>
  );
};

export default EmptyStylepacksRow;
